const parseUserId = () => {
  const { cookie } = document;
  const userId = parseInt(cookie.split("=")[1], 10);

  return userId;
};

const baseURL = process.env.NODE_ENV === "development"
  ? "http://localhost:8081/api" : "https://api.minhamola.com/api";

const requestBuilder = (url, httpMethod, data) => {
  const httpMethodsWithPayload = ["POST", "PUT"];

  if (httpMethodsWithPayload.includes(httpMethod)) {
    return {
      baseURL,
      url,
      withCredentials: "true",
      method: httpMethod,
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      data
    };
  } return {
    baseURL,
    url,
    withCredentials: "true",
    method: httpMethod
  };
};

const doNothing = () => 0;

const swOps = () => {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("./service-worker.js");
    });
  }
};

export { parseUserId, requestBuilder, doNothing, swOps };